import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface AdminToolbarProps {
    children: ReactNode;
    className?: string;
}

export function AdminToolbar({ children, className }: AdminToolbarProps) {
    return (
        <div
            className={cn("mb-3 flex flex-wrap items-center gap-2", className)}
        >
            {children}
        </div>
    );
}
